import styled from 'styled-components'

import Icon from '../Icon'

export const IconStyled = styled(Icon)`
  margin-right: 1rem;
`
